import moment from 'moment-timezone';

export class LeadCalendarMeeting {
	public id: number;
	public leadId: number;
	public date: Date | string;
	public subject: string;
	public recipients: string;
	public otherRecipients: string;
	public message: string;
	public details: string;
	public addDate: Date;

	constructor(leadCalendarMeeting?: Partial<LeadCalendarMeeting>) {
		Object.assign(this, leadCalendarMeeting);

		this.date = this.date ? new Date(moment(this.date).format('MMM DD, YYYY 00:00:00 a')) : this.date;
		this.addDate = this.addDate ? new Date(moment(this.addDate).format('MMM DD, YYYY 00:00:00 a')) : this.addDate;
	}
}
